export default __webpack_public_path__ + "static/media/cat2-3.10ccc0a9.jpg";